export default __webpack_public_path__ + "public/assets/images/f820818e5a202ea6aeffd02a589771ce.png";